/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Line_Col_CountedInputs */

const vi_stocktake_line_col_counted = /** @type {(inputs: Stocktake_Line_Col_CountedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm thực tế`)
};

/**

* @param {Stocktake_Line_Col_CountedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_line_col_counted = /** @type {((inputs?: Stocktake_Line_Col_CountedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Line_Col_CountedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_line_col_counted(inputs)
});